// 主表格組件
export default {
  // 表格列名
  month: "月份",
  date: "日期",
  inflowAmount: "轉入數量(萬元)",
  outflowAmount: "轉出數量(萬元)",

  // 合計行
  total: "合計",

  // 轉入轉出統計
  totalInflowAmount: "轉入總數量",
  totalOutflowAmount: "轉出總數量",
  tenThousand: "萬",
};
